// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container_2F-DU","parent":"Form_parent_HLC2l","infoBox":"Form_infoBox_2rSQ9"};